<template>
  <v-card class="mt-8">
    <v-card-title>Impressions et ratio</v-card-title>
    <v-card-subtitle>par jour de la semaine</v-card-subtitle>
    <v-card-text>
      <vue-apex-charts
        v-if="results"
        type="bar"
        :height="height"
        :options="chartOptions"
        :series="series"
      />
      <span v-else>{{ noDataText }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatNumber, formatPercent } from "@/utils/formatting";
import VueApexCharts from "vue-apexcharts";
import { noDataText } from "@/utils/constants";

export default {
  name: "WeekdaysPrintsRatioChart",
  components: {
    VueApexCharts,
  },
  async created() {
    await this.getData();
  },
  props: {
    sites: {
      type: Array,
      default: () => [],
    },
    partnerViews: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      noDataText,
      height: "355",
      legend: true,
      outlined: false,
      series: [],
      labels: [],
      formatter: (val) => formatNumber(val),
      chartOptions: {
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
            },
          },
        },
        legend: {
          show: this.legend,
          position: "bottom",
          fontSize: "14px",
          fontFamily: '"Inter", sans-serif',
        },
        colors: ["#4285F4", "#EA4335"],
        dataLabels: {
          enabled: this.datalabels,
          textAnchor: "middle",
          style: {
            colors: ["#373D3FFF"],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
          },
          offsetY: -30,
          formatter: this.formatter,
          dropShadow: {
            enabled: true,
          },
        },
        yaxis: [
          {
            min: 0,
            forceNiceScale: true,
            title: {
              text: "Ratio",
            },
            labels: {
              formatter: (val) => formatPercent(val),
            },
          },
          {
            min: 0,
            forceNiceScale: true,
            opposite: true,
            title: {
              text: "Nombre d'impressions",
            },
            labels: {
              formatter: (val) => formatNumber(val),
            },
          },
        ],
        tooltip: {
          shared: true,
          intersect: false,
          y: [
            {
              formatter: (val) => formatPercent(val),
            },
            {
              formatter: (val) => formatNumber(val),
            },
          ],
        },
        fill: {
          opacity: 1,
        },
      },
    };
  },
  methods: {
    updateOptions() {
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          categories: this.labels,
        },
        series: this.series,
        labels: this.labels,
      };
    },
    async getData() {
      if (!this.results) return;
      if ("items" in this.results) {
        const data = this.results.items;
        this.series = [
          {
            name: "Ratio",
            data: data.map((item) => item.ratio),
          },
          {
            name: "Nombre d'impressions",
            data: data.map((item) => item.impressions),
          },
        ];
        this.labels = data.map((item) => item.day);
      } else {
        this.series = [
          {
            name: "Ratio",
            data: [],
          },
          {
            name: "Nombre d'impressions",
            data: [],
          },
        ];
        this.labels = [];
      }
    },
  },
  computed: {
    results() {
      return this.$store.getters["gd/getData"]["weekdaysStats"];
    },
  },
  watch: {
    series() {
      this.updateOptions();
    },
    labels() {
      this.updateOptions();
    },
    results() {
      this.getData();
    },
  },
};
</script>
